import React from 'react';
import { ThreeDotMenu } from 'new/elements/ThreeDotMenu';
import { Nexset } from 'new/entities/Nexset';
import { Section } from 'new/elements/ThreeDotMenu/ThreeDotMenu';
import { ReactComponent as PauseIcon } from 'new/components/icons/pause.svg';
import { ReactComponent as CopyAltIcon } from 'new/components/icons/copyAlt.svg';
import { ReactComponent as CopyIcon } from 'new/components/icons/copy.svg';
import { ReactComponent as EditFileIcon } from 'new/components/icons/editFile.svg';
import { ReactComponent as DeleteIcon } from 'new/components/icons/fi-rr-trash.svg';
import { ReactComponent as PlayIcon } from 'new/components/icons/play.svg';
import { isActionAllowedForNodeType } from 'new/utils/nexsetActionRules';
import { isCapsuleCluster } from 'js/lib/PipelineUtils';

type NexsetWithFlow = Nexset & {
  origin_node_id?: number;
  flow_node_id?: number;
};

export const NexsetActions = (props: NexsetWithFlow) => {
  if (!props) {
    return null;
  }
  const { status } = props;
  const isActive = status === 'ACTIVE';
  const isCapsule = isCapsuleCluster(props);

  const nodeType = (props as any).node_type;

  const actions = [
    {
      section: 'NEXSET',
      actions: [
        ...(!isCapsule
          ? [
              {
                title: !isActive ? 'Activate' : 'Pause',
                icon: !isActive ? <PlayIcon /> : <PauseIcon />,
              },
            ]
          : []),
        ...(isActionAllowedForNodeType(nodeType, 'duplicate')
          ? ([
              {
                title: 'Duplicate',
                icon: <CopyAltIcon />,
              },
            ] as any)
          : []),
        {
          title: 'Edit',
          icon: <EditFileIcon />,
        },
        ...(isActionAllowedForNodeType(nodeType, 'pasteTransform')
          ? ([
              {
                title: 'Paste Transform',
                icon: <CopyIcon />,
              },
            ] as any)
          : []),
      ],
    },
    {
      actions: [
        {
          title: 'Delete',
          icon: <DeleteIcon />,
          color: 'error',
        },
      ],
    },
  ] as Section[];

  return <ThreeDotMenu actions={actions} />;
};
